export class Jurisdiction {
  id: string;
  name: string;
  state: string;
  operatingCompany: string;
}
